import { useState } from 'react';
import { Info } from 'lucide-react';

interface VideoCategoryBadgeProps {
  primary: string;
  additional?: string[];
  type: 'industry' | 'purpose';
}

export function VideoCategoryBadge({ primary, additional = [], type }: VideoCategoryBadgeProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const hasAdditional = additional.length > 0;
  
  const colors = type === 'industry' 
    ? {
        bg: 'bg-[#2F2E5C]/10',
        text: 'text-[#2F2E5C]',
        border: 'border-[#2F2E5C]/20',
        tooltipBg: 'bg-[#2F2E5C]'
      }
    : {
        bg: 'bg-[#D74444]/10',
        text: 'text-[#D74444]',
        border: 'border-[#D74444]/20',
        tooltipBg: 'bg-[#D74444]'
      };
  
  return (
    <div className="relative inline-block">
      <span 
        className={`inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full ${colors.bg} ${colors.text} font-semibold border ${colors.border} shadow-sm transition-all ${hasAdditional ? 'cursor-help hover:shadow-md' : ''}`}
        onMouseEnter={() => hasAdditional && setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <span>{primary}</span>
        {hasAdditional && (
          <span className="inline-flex items-center gap-0.5 opacity-70">
            <Info className="w-3 h-3" />
            <span className="text-[10px] font-bold">+{additional.length}</span>
          </span>
        )}
      </span>
      
      {/* Tooltip */}
      {hasAdditional && showTooltip && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 animate-in fade-in slide-in-from-bottom-1 duration-200">
          <div className={`${colors.tooltipBg} text-white text-xs rounded-lg px-3 py-2 shadow-xl whitespace-nowrap`}>
            <div className="font-semibold mb-1">Also tagged as:</div>
            <div className="space-y-0.5">
              {additional.map((item, i) => (
                <div key={i} className="opacity-90">• {item}</div>
              ))}
            </div>
          </div>
          {/* Arrow */}
          <div className={`absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent ${type === 'industry' ? 'border-t-[#2F2E5C]' : 'border-t-[#D74444]'}`} />
        </div>
      )}
    </div>
  );
}
